import { Component, Input } from '@angular/core';
import { APPCONFIG } from '../../config'

@Component({
    selector: 'my-app-sidenav',
    template: require('./sidenav.component.html'),
    styles:[require('./sidenav.component.scss')]
})

export class AppSidenavComponent {
    AppConfig;
    dynamicClass:String;
    ngOnInit() {
        this.AppConfig = APPCONFIG;
        var host=window.location.host;
        if(host.indexOf("ka.")>-1)
        {
            this.dynamicClass="nav-light-red";
        }
        else{this.dynamicClass="nav-light-yellow";}
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav.component.ts